import React from 'react';
import { node, oneOfType, shape, string } from 'prop-types';
import styled from '@emotion/styled';

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

/**
 * Vertical Stack component.
 * @example
 * <Vstack>
 *   <div>Hello</div>
 *   <div>World</div>
 * </Vstack>
 */
const VStack = ({
  children,
  top,
  right,
  bottom,
  left,
  align,
  height,
  justify,
  padding,
  style,
  width,
  ...props
}) => {
  const styVStack = {
    alignItems: align,
    height,
    justifyContent: justify,
    marginTop: top,
    marginRight: right,
    marginBottom: bottom,
    marginLeft: left,
    padding,
    width,
    ...style,
  };

  return (
    <StyledDiv style={styVStack} {...props}>
      {children}
    </StyledDiv>
  );
};

VStack.propTypes = {
  children: oneOfType([node, string]), // React.ReactNode
  top: string, // CSS.Property.MarginTop
  right: string, // CSS.Property.MarginRight
  left: string, // CSS.Property.MarginLeft
  bottom: string, // CSS.Property.MarginBottom
  align: string, // CSS.Property.AlignItems
  height: string, // CSS.Property.Height
  justify: string, // CSS.Property.JustifyContent
  padding: string, // CSS.Property.Padding
  style: shape({}), // CSS.Property
  width: string, // CSS.Property.Width
};

VStack.defaultProps = {
  children: null,
  top: '',
  right: '',
  left: '',
  bottom: '',
  align: '',
  height: '',
  justify: '',
  padding: '',
  style: {},
  width: '',
};

export default VStack;
